import './Coverages.css';

import React from 'react';

import { lobTypeToProductLabel } from './configs/productLabels';

interface IneligibleCoverageProps {
  /** The application's lobType (e.g. 'EO'), used to render the product label. */
  lobType: string;
}

/**
 * Card shown in place of the normal Coverages card when the rating/quoting
 * backend declines a single product (getQuote returns GetQuoteDecline) while
 * at least one other product in the group is still quotable. The customer
 * stays on the quote page and buys the eligible product(s); a Foxquilt agent
 * follows up about the declined one.
 */
export const IneligibleCoverage: React.FC<IneligibleCoverageProps> = ({
  lobType
}) => {
  const productLabel = lobTypeToProductLabel(lobType);

  return (
    // Scoped by lobType so a test can assert which product was declined while
    // its siblings were quoted, rather than only that some card is present.
    <div
      data-testid={`ineligible-coverage-${lobType}`}
      className="coverages-container mt-2 md:mt-0"
    >
      <div className="ineligible-coverages-header px-8 py-4 font-bold text-2xl text-quartary">
        <p>For Your {productLabel} Policy:</p>
      </div>
      <div className="coverages-inner-container px-8 pt-4 pb-8">
        <p className="text-quartary text-xl md:text-2xl font-bold mb-4">
          Unfortunately, our Foxquilt {productLabel} product won&apos;t be a
          great match for your business.
        </p>
        <p className="text-gray-700 mb-4 text-xs md:text-base">
          Making sure you&apos;re getting the best possible coverage for your
          business is our priority so our team of insurance experts are going to
          work on finding an insurance solution with the info you provided.
        </p>
        <p className="text-gray-700 text-xs md:text-base">
          They&apos;ll be in touch shortly with some options - or if you&apos;d
          prefer, you can reach out to them at{' '}
          <a href="mailto:hello@foxquilt.com" className="text-secondary">
            hello@foxquilt.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default IneligibleCoverage;
